





































































































/**
 * FUPOF-191: the rep is about to create a NetSuite prospect for a company
 * NetSuite already has. Shown from two places, and answered the same way in
 * both — switch the quote to the existing customer, or say that this really is
 * a separate company (two real businesses do share a name).
 *
 *  - Quote Contact, as soon as the check finds a match: the cheapest moment to
 *    fix it, before the rest of the quote is filled in against a customer that
 *    shouldn't exist.
 *  - Order Review, when the API refuses the create with a 409: the backstop for
 *    what the form-side check couldn't catch — a company matched only by email,
 *    or a name filled in faster than the check could answer.
 *
 * It cannot be dismissed by clicking away or closing, because a duplicate
 * prospect is not an outcome the rep should be able to reach by ignoring this.
 */

import { Vue, Component, Prop } from "vue-property-decorator";
import { DuplicateCustomerMatch } from "@/models/netsuite/netsuite";

@Component
export default class DuplicateCustomer extends Vue {
  @Prop({ default: "This customer already exists" }) title!: string;
  /** The API's own account of the match. Blank on the form-side check, which
   *  has no server message — the per-row reasons carry the detail there. */
  @Prop({ default: "" }) message!: string;
  @Prop({ default: () => [] }) matches!: DuplicateCustomerMatch[];
  @Prop({ default: "Create a separate customer" }) confirmLabel!: string;
  /** Blank renders no second button, for the caller whose only other answer is
   *  the confirm one. There is deliberately no other way to close this. */
  @Prop({ default: "Go back" }) cancelLabel!: string;

  get leadMessage(): string {
    return (
      this.message ||
      "NetSuite already has a company that looks like the one being entered here."
    );
  }

  /**
   * Why this record was matched — the evidence line, and nothing else. Whose
   * customer it is gets its own line in the row, so a match with a sales rep
   * and one without still line up.
   */
  protected matchReason(match: DuplicateCustomerMatch): string {
    switch (match.match) {
      case "contact_email":
        return `${match.contact_name ||
          "A contact"} is already a contact there${
          match.email ? ` at ${match.email}` : ""
        }`;
      case "email":
        return "That email address is already on this customer's record";
      case "name":
        return "Same company name";
      default:
        return "Similar company name";
    }
  }

  protected closeModal(): void {
    this.$emit("close");
  }
}
